import React from 'react';
import { connect } from 'react-redux';
import i18n from '../../i18n/i18n';
import {
    TextField, Button, Grid, IconButton,
    Dialog, DialogContent, DialogTitle
} from '@material-ui/core';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    getZones, addStateManager, getStates,
    setInitialState
} from '../../actions/AdministrationActions';
import { getLocalGov } from '../../actions/FarmRegistarActions';
import { getUser } from '../../utils/CommonFunctions';


export class AddState extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            statesObj: {}
        };
    }

    async componentDidMount() {
        this.props.getZones();
        let user = await getUser();
        if (user) {
            this.props.getStates();
            this.props.getLocalGov();
            const { statesObj } = this.state;
            let obj = Object.assign({}, statesObj);
            obj.id_zona = user.id_zona;
            this.setState({
                statesObj: obj
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.statesPostingFailed === true) {
            toast.error(i18n.t('Something went wrong, please try again!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('statesPostingFailed');
        }
        this.setState({
            zones: nextProps.zones,
            zonesFetching: nextProps.zonesFetching,
            zonesFetchingFailed: nextProps.zonesFetchingFailed,

        })
    }


    handleChangeValue = name => event => {
        const { statesObj } = this.state;
        let obj = Object.assign({}, statesObj);
        obj[name] = event.target.value;
        this.setState({ statesObj: obj });
    };

    addStateManager() {
        const { statesObj } = this.state;
        if (statesObj.kontakt_mejl &&
            statesObj.id_katastarska_opstina &&
            statesObj.id_opstina &&
            statesObj.ime &&
            statesObj.prezime &&
            statesObj.username &&
            statesObj.password) {
            this.props.addStateManager(
                statesObj
            )

        } else {
            toast.error(i18n.t('Please enter all required fields!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
        }
    }


    render() {
        const { localGoverments, localGovermentsFetching, states, statesFetching, zones, zonesFetching, add, handleClose } = this.props;
        const { statesObj } = this.state;
        let zonesArray = [];
        if (zones && !zonesFetching) {
            zonesArray = zones.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        let statesArray = [];
        if (states && !statesFetching) {
            statesArray = states.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        let localGovermentsArray = [];
        if (localGoverments && !localGovermentsFetching) {
            localGovermentsArray = localGoverments.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        return (
            <div style={{ padding: 20 }}>
                <Dialog
                    open={add}
                    onClose={handleClose}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle disableTypography={true} className="responsive-dialog-title">{i18n.t('Add state officer')}
                        <IconButton onClick={handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <form id="add-zonal">
                            <Grid container justify="space-between" alignContent="space-between" spacing={16} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                                <TextField
                                    label={i18n.t('First name')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={statesObj.ime}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('ime')}
                                />
                                <TextField
                                    label={i18n.t('Last name')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={statesObj.prezime}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('prezime')}
                                />
                                <TextField
                                    label={i18n.t('Username')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={statesObj.username}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('username')}
                                />
                                <TextField
                                    label={i18n.t('Password')}
                                    type="password"
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('password')}
                                />
                                <TextField
                                    select
                                    label={i18n.t('Zone')}
                                    value={statesObj.id_zona}
                                    required
                                    disabled
                                    onChange={this.handleChangeValue('id_zona')}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    margin="normal"
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}

                                >

                                    <option value='' />
                                    {zonesArray}
                                </TextField>
                                <TextField
                                    select
                                    label={i18n.t('State')}
                                    value={statesObj.id_opstina}
                                    required
                                    onChange={this.handleChangeValue('id_opstina')}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    margin="normal"
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}

                                >

                                    <option value='' />
                                    {statesArray}
                                </TextField>

                                <TextField
                                    select
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    label={i18n.t('Local government')}
                                    value={statesObj.id_katastarska_opstina}
                                    required
                                    onChange={this.handleChangeValue('id_katastarska_opstina')}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    margin="normal"
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}

                                >

                                    <option value='' />
                                    {localGovermentsArray}
                                </TextField>

                                <TextField
                                    label={i18n.t('Address')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={statesObj.ulica_i_broj}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('ulica_i_broj')}
                                />

                                <TextField
                                    label={i18n.t('Zip code')}
                                    value={statesObj.postanski_broj}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('postanski_broj')}
                                />

                                <TextField
                                    label={i18n.t('Email')}
                                    value={statesObj.kontakt_mejl}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('kontakt_mejl')}
                                />

                                <TextField
                                    label={i18n.t('Phone')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={statesObj.kontakt_telefon}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('kontakt_telefon')}
                                />
                                <Grid item xs={12}>
                                </Grid>
                                <Grid item xs>
                                    <Button
                                        style={{ alignSelf: 'center', backgroundColor: '#61a50e', color: 'white' }}
                                        onClick={() => this.addStateManager()}
                                    >
                                        {i18n.t('Add')}
                                    </Button>
                                </Grid>
                                <Grid item xs={3}>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>

        )
    }
};

function mapStateToProps(state) {
    return {
        zones: state.administrationReducer.zones,
        zonesFetching: state.administrationReducer.zonesFetching,
        statesObj: state.administrationReducer.statesObj,
        zonesFetchingFailed: state.administrationReducer.zonesFetchingFailed,
        states: state.administrationReducer.states,
        statesFetching: state.administrationReducer.statesFetching,
        statesFetchingFailed: state.administrationReducer.statesFetchingFailed,
        statesPostingFailed: state.administrationReducer.statesPostingFailed,
        localGoverments: state.farmRegistarReducer.localGoverments,
        localGovermentsFetching: state.farmRegistarReducer.localGovermentsFetching,
        localGovermentsFetchingFailed: state.farmRegistarReducer.localGovermentsFetchingFailed,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getZones: () => dispatch(getZones()),
        getStates: () => dispatch(getStates()),
        getLocalGov: (id_state) => getLocalGov(id_state),
        setInitialState: (component) => dispatch(setInitialState(component)),
        addStateManager: (statesObj) => dispatch(addStateManager(statesObj)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddState)